import React from 'react';
import ChoroplethSvg from '@splunk/dashboard-visualizations/ChoroplethSvg';
import { campusSvgDataURI } from '../../mockdata/campusSvgDataURI.js';

const CampusData = {
    fields: [
        {
            name: 'buildings',
        },
        {
            name: 'values',
        },
    ],
    columns: [
        ['ATX-270-B', 'N-224', 'VM-203', 'RF-380'],
        [10000, 55000, 90000, 75000],
    ],
};

const rangevalueEncoding = {
    featureId: 'primary[0]',
    value: 'primary[1]',
    fill: {
        field: 'primary[1]',
        format: {
            type: 'rangevalue',
            ranges: [
                { from: 80000, value: '#4BEBA8' },
                { from: 60000, to: 80000, value: '#F4DF7A' },
                { from: 20000, to: 60000, value: '#FC9850' },
                { to: 20000, value: '#FF7152' },
            ],
        },
    },
};

const baseProps = {
    width: 700,
    height: 500,
    options: {
        svg: campusSvgDataURI,
    },
    dataSources: {
        primary: { data: CampusData },
    },
};

export default () => <ChoroplethSvg {...baseProps} encoding={rangevalueEncoding} />;
